import { cResource } from "./resource";


export interface resourceclosings {
    id: string;
    resourceid: string;
    resourceclosingid: string;    
    name: string;  
    resourcetoclose: cResource;
    disabled: boolean;  
    venueid: string;  
    startdate: string,
    enddate: string,
    publicmessage: string;
    venuemessage: string;
    closingbasedonday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  }
  export class cResourceclosings implements resourceclosings {
    id: string;
    resourceid: string;
    resourceclosingid: string;    
    name: string;  
    resourcetoclose: cResource;
    disabled: boolean;  
    venueid: string;  
    startdate: string;
    enddate: string;
    publicmessage: string;
    venuemessage: string;
    closingbasedonday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  }
